import { UserIcon } from "pages/[tenant]/console/assets/icons/UserIcon";
import { IOption, IOptionsHook } from "pages/[tenant]/console/types";

import { useAuthContext } from "shared/utils/hooks/useAuthContext";

export const usePeopleOptions = (): IOptionsHook => {
  const { rolesUser } = useAuthContext();

  const hasPermission = (permissionsList: string[]): boolean =>
    rolesUser?.some((permission) => permissionsList?.includes(permission));

  const shouldHideOption = (permissionsList?: string[], condition = true) =>
    !condition || (permissionsList && !hasPermission(permissionsList));

  const sectionLabel = "Pessoas";
  const options: IOption[] = [
    {
      id: 1,
      label: "Usuários ativos",
      description:
        "Esses são todos os usuários com acesso pleno às suas contas. Um usuário ativo pode ou não estar ativamente utilizando a plataforma.",
      path: "/console/users/active",
      icon: <UserIcon />,
      shouldHide: shouldHideOption(["visualizar-lista-de-usuarios-ativos"]),
    },
    {
      id: 2,
      label: "Usuários desabilitados",
      description:
        "Esses usuários já não possuem mais acesso às suas contas e seus registros permanecem para que você possa reativá-los mais tarde.",
      path: "/console/users/disabled",
      icon: <UserIcon />,
      shouldHide: shouldHideOption(["visualizar-lista-de-usuarios-excluidos"]),
    },
    {
      id: 3,
      label: "Todos os usuários",
      description:
        "Gerencie e visualize informações sobre cada usuário ativo ou excluído que já passaram por sua plataforma.",
      path: "/console/users",
      icon: <UserIcon />,
      shouldHide:
        shouldHideOption(["visualizar-lista-de-usuarios-excluidos"]) ||
        shouldHideOption(["visualizar-lista-de-usuarios-ativos"]),
    },
  ];

  return {
    label: sectionLabel,
    options,
  };
};
